var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "storefinder__mapSection" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.optIn,
            expression: "optIn",
          },
        ],
        ref: "map",
        staticClass: "storefinder__map",
      }),
      _vm._v(" "),
      !_vm.optIn
        ? _c(
            "div",
            { staticClass: "storefinder__map map__opt-in" },
            [
              _vm._t("optIn", null, {
                isOptedIn: _vm.optIn,
                allowMap: _vm.allowOptIn,
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, {
        isOptedIn: _vm.optIn,
        allowMap: _vm.allowOptIn,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }